import { INoRowsOverlayAngularComp } from "ag-grid-angular";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { TableComponentState } from "../../../shared/types/TableComponentState";
import { NoRowsFunctionInfo } from "../../../shared/types/NoRowsFunctionInfo";
import { INoRowsOverlayParams } from "ag-grid-community";
import { Store } from "@ngrx/store";
import { selectInitReleaseTableState, selectInitReleaseTableUpdatedState } from "../../reducers";
import { InitReleaseActions } from "../../actions";
import {NoRowsMessageTemplates} from "../../../shared/utilities/Constants";

@Component({
  standalone: false,
    selector: 'mm-custom-error-init-release-table',
    templateUrl: './custom-error-init-release-table.component.html',
    styleUrls: ['./custom-error-init-release-table.component.scss']
})

export class CustomErrorInitReleaseTableComponent implements OnInit, OnDestroy, INoRowsOverlayAngularComp {
    params: INoRowsOverlayParams & { noRowsMessageFn: () => NoRowsFunctionInfo  };
    tableState$: Observable<TableComponentState>;
    accountId: string;
    viewTransactionStatusClicked: boolean;
    createAnotherRequestClicked: boolean;
    noRowsMessageTemplates = NoRowsMessageTemplates;
    private destroy$ = new Subject<void>();

    constructor(private store: Store) { }

    ngOnInit(): void {
        this.tableState$ = this.store.select(selectInitReleaseTableUpdatedState);
    }

    refreshTable() {
        this.store.dispatch(InitReleaseActions.getInitReleaseList());
    }

    ngOnDestroy(): void {
        this.destroy$?.next();
        this.destroy$?.unsubscribe();
    }

    agInit(params: INoRowsOverlayParams & { noRowsMessageFn: () => NoRowsFunctionInfo  }): void {
        this.params = params;
    }
}
